module.exports = __webpack_public_path__ + "media/pro/at-bay-logo-9033d733.png";